import { createSlice, createListenerMiddleware } from '@reduxjs/toolkit';
import { isPlatformNodeJS } from '@utils/common';
import { createIndependentStore } from '@utils/react';

const slice = createSlice({
  name: "@pm2/ui-store",
  initialState: {},
  reducers: {
    setPendingMegaMenu(state, action) {
      state.pendingMegaMenu = action.payload;
    },
    openMegaMenu(state, action) {
      state.megaMenu = [action.payload];
      state.pendingMegaMenu = void 0;
    },
    setMegaMenu(state, action) {
      state.megaMenu = action.payload;
      state.pendingMegaMenu = void 0;
    },
    pushMegaMenuLayer(state, action) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.push(action.payload);
    },
    replaceMegaMenuLayer(state, action) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.splice(-1, 1, action.payload);
    },
    popMegaMenu(state) {
      var _a;
      (_a = state.megaMenu) == null ? void 0 : _a.pop();
    },
    closeMegaMenu(state) {
      state.megaMenu = void 0;
      state.pendingMegaMenu = void 0;
    },
    openLeftAside(state, action) {
      state.leftAside = action.payload;
    },
    closeLeftAside(state) {
      state.leftAside = void 0;
    },
    openRightAside(state, action) {
      state.rightAside = action.payload;
    },
    closeRightAside(state) {
      state.rightAside = void 0;
    },
    openIbookPreview(state, action) {
      state.ibookPreviewId = action.payload;
    },
    closeIbookPreview(state) {
      state.ibookPreviewId = void 0;
    },
    openLightbox(state, action) {
      state.lightboxContent = action.payload.content;
      state.lightboxSpeechFile = action.payload.speechFile;
    },
    closeLightbox(state) {
      state.lightboxContent = void 0;
      state.lightboxSpeechFile = void 0;
    },
    toggleResources(state, action) {
      state.showResources = action.payload ?? !state.showResources;
    }
  }
});
const middleware = createListenerMiddleware();
middleware.startListening.withTypes()({
  predicate: () => true,
  effect: async (action) => {
    if (isPlatformNodeJS()) {
      return;
    }
    switch (true) {
      case slice.actions.openLeftAside.match(action): {
        document.body.classList.add("aside--left");
        document.body.classList.toggle(
          "aside--left--prevent-overlap",
          action.payload.preventOverlap
        );
        break;
      }
      case slice.actions.closeLeftAside.match(action): {
        document.body.classList.remove(
          "aside--left",
          "aside--left--prevent-overlap"
        );
        break;
      }
      case slice.actions.openRightAside.match(action): {
        document.body.classList.add("aside--right");
        document.body.classList.toggle(
          "aside--right--prevent-overlap",
          action.payload.preventOverlap
        );
        break;
      }
      case slice.actions.closeRightAside.match(action): {
        document.body.classList.remove(
          "aside--right",
          "aside--right--prevent-overlap"
        );
        break;
      }
    }
  }
});
const pm2InterfaceStore = createIndependentStore({
  ...slice,
  middleware: (getDefaultMiddleWare) => getDefaultMiddleWare().prepend(middleware.middleware)
});

export { pm2InterfaceStore };
//# sourceMappingURL=store.interface.js.map
